/* eslint-disable no-use-before-define */

const { FLUX_SYNCUP, obtenirFluxSyncUp } = require('./catalogueFluxSyncUp');

const VERSION_CONTRAT_DIAGNOSTIC_SYNCUP = 'syncup.cockpit.diagnostic.v1';

function diagnostiquerObjetSyncUp(source = {}, requete = {}) {
  const contexte = construireContexte(source, requete);
  const diagnostics = FLUX_SYNCUP.map((flux) => {
    if (flux.id === 'parent-enfants') return diagnostiquerParentEnfants(flux, contexte);
    return diagnosticNonInterprete(flux, contexte);
  });

  return {
    versionContrat: 'syncup.cockpit.resultat-recherche.v1',
    requete: contexte.requete,
    objetRacine: contexte.utilisateur ? objetUtilisateur(contexte.utilisateur) : {
      type: 'utilisateur',
      id: contexte.requete,
      libelle: contexte.requete || 'Utilisateur non selectionne',
      etat: 'inconnu',
    },
    periode: contexte.periode,
    diagnostics,
    flux: FLUX_SYNCUP,
    sourcesSql: source.sourcesSql || {},
    avertissements: source.avertissements || [],
  };
}

function diagnostiquerParentEnfants(flux, contexte) {
  const preuvesPositives = [];
  const preuvesNegatives = [];
  const preuvesManquantes = [];
  const contradictions = [];
  const utilisateur = contexte.utilisateur;
  const enfantsAttendus = contexte.enfantsAttendus;
  const enfantsProjetes = contexte.enfantsProjetes;

  if (utilisateur) {
    ajouterPreuve(preuvesPositives, 'parent_trouve', 'Utilisateur parent trouve.', 'syncup.utilisateurs', utilisateur.id, utilisateur.updatedAt, {
      statut: utilisateur.statut,
      organisationId: utilisateur.organisationId,
    });
  } else {
    ajouterPreuve(preuvesNegatives, 'parent_absent', 'Aucun utilisateur ne correspond a la recherche.', 'syncup.utilisateurs', contexte.requete);
  }

  if (utilisateur && utilisateur.statut === 'actif') {
    ajouterPreuve(preuvesPositives, 'parent_actif', 'Le compte parent est actif.', 'syncup.utilisateurs', utilisateur.id);
  } else if (utilisateur) {
    ajouterPreuve(preuvesNegatives, 'parent_inactif', 'Le compte parent n est pas actif.', 'syncup.utilisateurs', utilisateur.id, utilisateur.updatedAt, {
      statut: utilisateur.statut || 'inconnu',
    });
  }

  enfantsAttendus.forEach((enfant) => {
    ajouterPreuve(preuvesPositives, 'enfant_trouve', `Enfant source trouve: ${enfant.nom}.`, 'syncup.enfants', enfant.id, enfant.updatedAt, {
      organisationId: enfant.organisationId,
    });
  });

  if (utilisateur && enfantsAttendus.length === 0) {
    ajouterPreuve(preuvesManquantes, 'relation_parent_enfant_absente', 'Aucune relation parent/enfant active trouvee en source.', 'syncup.relationsParentEnfant', utilisateur.id);
  }

  contexte.relationsParentEnfant.forEach((relation) => {
    const enfant = contexte.enfantsParId[relation.enfantId];
    const libelleEnfant = enfant ? enfant.nom : relation.enfantId;
    if (relation.etat === 'active') {
      ajouterPreuve(preuvesPositives, 'relation_active_trouvee', `Relation active vers ${libelleEnfant}.`, 'syncup.relationsParentEnfant', relation.id, relation.updatedAt, {
        parentId: relation.parentId,
        enfantId: relation.enfantId,
        organisationId: relation.organisationId,
      });
    } else {
      ajouterPreuve(preuvesNegatives, 'relation_inactive', `Relation non active vers ${libelleEnfant}.`, 'syncup.relationsParentEnfant', relation.id, relation.updatedAt, {
        etat: relation.etat || 'inconnu',
      });
    }

    if (utilisateur && relation.organisationId && utilisateur.organisationId && relation.organisationId !== utilisateur.organisationId) {
      ajouterPreuve(preuvesNegatives, 'relation_autre_organisation', `Relation rattachee a une autre organisation pour ${libelleEnfant}.`, 'syncup.relationsParentEnfant', relation.id, relation.updatedAt, {
        organisationParent: utilisateur.organisationId,
        organisationRelation: relation.organisationId,
      });
    }
  });

  enfantsAttendus.forEach((enfant) => {
    const projete = enfantsProjetes.find((item) => item.id === enfant.id);
    if (projete) {
      ajouterPreuve(preuvesPositives, 'enfant_present_projection', `Projection enfants visibles contient ${enfant.nom}.`, 'syncup.projection.enfantsVisibles', utilisateur.id, projete.projectedAt, {
        enfantId: enfant.id,
      });
    } else {
      ajouterPreuve(preuvesNegatives, 'enfant_absent_projection', `Projection enfants visibles ne contient pas ${enfant.nom}.`, 'syncup.projection.enfantsVisibles', utilisateur ? utilisateur.id : contexte.requete, contexte.projection && contexte.projection.updatedAt, {
        enfantId: enfant.id,
      });
    }
  });

  if (utilisateur && !contexte.projection) {
    ajouterPreuve(preuvesManquantes, 'projection_enfants_visibles_absente', 'Aucune projection enfants visibles disponible pour ce parent.', 'syncup.projection.enfantsVisibles', utilisateur.id);
  }

  const idsAttendus = enfantsAttendus.map((enfant) => enfant.id).sort();
  const idsProjetes = enfantsProjetes.map((enfant) => enfant.id).sort();
  if (idsAttendus.length > 0 && idsProjetes.length > 0) {
    idsProjetes
      .filter((id) => idsAttendus.indexOf(id) < 0)
      .forEach((id) => {
        contradictions.push(preuve('projection_enfant_inattendu', 'La projection contient un enfant non attendu par les relations actives.', 'syncup.projection.enfantsVisibles', utilisateur ? utilisateur.id : contexte.requete, contexte.projection && contexte.projection.updatedAt, { enfantId: id }));
      });
  }

  const etat = determinerEtatParentEnfants({ utilisateur, enfantsAttendus, enfantsProjetes, preuvesNegatives, preuvesManquantes, contradictions });
  const scoreConfiance = determinerConfiance({ etat, preuvesPositives, preuvesNegatives, preuvesManquantes, contradictions });
  const raisonPrincipale = raisonParentEnfants(etat, { utilisateur, enfantsAttendus, enfantsProjetes, preuvesNegatives, preuvesManquantes, contradictions });

  return diagnosticContrat(flux, contexte, {
    etat,
    scoreConfiance,
    raisonPrincipale,
    preuvesPositives,
    preuvesNegatives,
    preuvesManquantes,
    contradictions,
    projectionAttendue: {
      type: 'enfants_visibles_parent',
      parentId: utilisateur ? utilisateur.id : contexte.requete,
      enfants: enfantsAttendus.map((enfant) => ({
        id: enfant.id,
        nom: enfant.nom,
      })),
    },
    projectionObservee: {
      type: 'enfants_visibles_parent',
      parentId: utilisateur ? utilisateur.id : contexte.requete,
      source: contexte.projection ? 'syncup.projection.enfantsVisibles' : 'absente',
      updatedAt: contexte.projection ? contexte.projection.updatedAt : '',
      enfants: enfantsProjetes.map((enfant) => ({
        id: enfant.id,
        nom: enfant.nom,
      })),
    },
    interpretation: interpretationParentEnfants(etat, { utilisateur, enfantsAttendus, enfantsProjetes, preuvesNegatives, preuvesManquantes }),
    prochaineVerification: prochaineVerificationParentEnfants(etat, { utilisateur, enfantsAttendus, enfantsProjetes, preuvesNegatives, preuvesManquantes }),
    liensCorrection: utilisateur ? [{
      libelle: 'Ouvrir le parent dans l administration',
      url: `/users?search=${encodeURIComponent(utilisateur.id)}`,
      risque: 'Le Cockpit explique seulement le probleme; toute correction reste dans l administration.',
    }] : [],
  });
}

function construireContexte(source, requete) {
  const periode = source.periode || periodeJourCourant();
  const texteRecherche = normaliserRecherche(requete && (requete.utilisateurId || requete.q || requete.requete));
  const utilisateurs = source.utilisateurs || [];
  const utilisateur = rechercherUtilisateur(utilisateurs, texteRecherche);
  const relations = source.relationsParentEnfant || [];
  const enfants = source.enfants || [];
  const projections = source.projectionsEnfantsVisibles || [];
  const relationsParentEnfant = utilisateur
    ? relations.filter((relation) => String(relation.parentId) === String(utilisateur.id))
    : [];
  const enfantsParId = indexerParId(enfants);
  const enfantsAttendus = relationsParentEnfant
    .filter((relation) => relation.etat === 'active')
    .map((relation) => enfantsParId[relation.enfantId])
    .filter(Boolean);
  const projection = utilisateur
    ? projections.find((item) => String(item.parentId) === String(utilisateur.id))
    : null;
  const enfantsProjetes = ((projection && projection.enfants) || [])
    .map((item) => typeof item === 'string' ? enfantsParId[item] || { id: item, nom: item } : item)
    .filter(Boolean);

  return {
    source,
    requete: texteRecherche,
    periode,
    utilisateur,
    relationsParentEnfant,
    enfantsParId,
    enfantsAttendus,
    projection,
    enfantsProjetes,
  };
}

function diagnosticNonInterprete(flux, contexte) {
  return diagnosticContrat(flux, contexte, {
    etat: 'non_interprete',
    scoreConfiance: 'nul',
    raisonPrincipale: 'Flux connu du catalogue, mais moteur non encore implemente.',
    preuvesPositives: [],
    preuvesNegatives: [],
    preuvesManquantes: [preuve('interpreteur_absent', 'Aucun interpreteur SyncUp n est encore branche pour ce flux.', 'cockpit.syncup.catalogue', flux.id)],
    contradictions: [],
    projectionAttendue: {},
    projectionObservee: {},
    interpretation: 'Ce flux est reserve dans l architecture et pourra etre ajoute sans changer le contrat de diagnostic.',
    prochaineVerification: 'Prioriser ce flux lorsque les sources observables seront disponibles.',
    liensCorrection: [],
  });
}

function diagnosticContrat(flux, contexte, resultat) {
  return {
    versionContrat: VERSION_CONTRAT_DIAGNOSTIC_SYNCUP,
    requete: contexte.requete,
    periode: contexte.periode,
    flux: {
      id: flux.id,
      nom: flux.nom,
      objectif: flux.objectif,
      categorie: flux.categorie,
    },
    objetRacine: contexte.utilisateur ? objetUtilisateur(contexte.utilisateur) : {
      type: 'utilisateur',
      id: contexte.requete,
      libelle: contexte.requete || 'Utilisateur non selectionne',
      etat: 'inconnu',
    },
    etat: resultat.etat,
    scoreConfiance: resultat.scoreConfiance,
    raisonPrincipale: resultat.raisonPrincipale,
    preuvesPositives: resultat.preuvesPositives || [],
    preuvesNegatives: resultat.preuvesNegatives || [],
    preuvesManquantes: resultat.preuvesManquantes || [],
    contradictions: resultat.contradictions || [],
    projectionAttendue: resultat.projectionAttendue || {},
    projectionObservee: resultat.projectionObservee || {},
    interpretation: resultat.interpretation || '',
    prochaineVerification: resultat.prochaineVerification || '',
    liensCorrection: resultat.liensCorrection || [],
  };
}

function determinerEtatParentEnfants({ utilisateur, enfantsAttendus, enfantsProjetes, preuvesNegatives, preuvesManquantes, contradictions }) {
  if (contradictions.length > 0) return 'contradictoire';
  if (!utilisateur) return 'bloque';
  if (preuvesNegatives.some((item) => item.code === 'parent_inactif')) return 'bloque';
  if (preuvesNegatives.some((item) => item.code === 'relation_autre_organisation')) return 'bloque';
  if (enfantsAttendus.length > 0 && enfantsAttendus.every((enfant) => enfantsProjetes.some((item) => item.id === enfant.id))) return 'sain';
  if (enfantsAttendus.length > 0 && preuvesNegatives.some((item) => item.code === 'enfant_absent_projection')) return 'bloque';
  if (preuvesManquantes.length > 0) return 'inconnu';
  return 'inconnu';
}

function determinerConfiance({ etat, preuvesPositives, preuvesNegatives, contradictions }) {
  if (etat === 'contradictoire') return 'fort';
  if (preuvesNegatives.length > 0) return 'fort';
  if (preuvesPositives.some((item) => item.code === 'enfant_present_projection')) return 'fort';
  if (preuvesPositives.length >= 2) return 'moyen';
  return 'faible';
}

function raisonParentEnfants(etat, details) {
  if (!details.utilisateur) return 'Utilisateur parent introuvable.';
  if (details.preuvesNegatives.some((item) => item.code === 'parent_inactif')) return 'Le compte parent n est pas actif.';
  if (details.preuvesNegatives.some((item) => item.code === 'relation_autre_organisation')) return 'La relation parent/enfant est rattachee a un autre contexte organisationnel.';
  if (details.contradictions.length > 0) return 'La projection contient des enfants incompatibles avec les relations actives.';
  if (etat === 'sain') return 'Les relations actives et la projection enfants visibles convergent.';
  if (details.enfantsAttendus.length === 0) return 'Aucune relation parent/enfant active n est prouvee en source.';
  if (details.enfantsProjetes.length === 0) return 'Relation active trouvee, mais projection enfants visibles absente ou vide.';
  return 'Relation parent/enfant absente de la projection enfants visibles.';
}

function interpretationParentEnfants(etat, details) {
  if (etat === 'sain') {
    return 'Le parent existe, la relation active existe et l enfant attendu est visible dans la projection observee.';
  }
  if (!details.utilisateur) {
    return 'Le Cockpit ne peut pas interpreter la relation parent/enfant tant que le parent n est pas resolu.';
  }
  if (details.enfantsAttendus.length > 0 && details.enfantsProjetes.length === 0) {
    return 'La source metier connait au moins une relation active, mais aucun effet visible n est observe dans la projection du parent.';
  }
  if (details.preuvesManquantes.length > 0) {
    return 'Les preuves disponibles ne suffisent pas a conclure; le Cockpit expose les signaux manquants au lieu d inventer une cause.';
  }
  return 'Le diagnostic pointe une divergence entre ce que le parent devrait voir et ce qui est observe.';
}

function prochaineVerificationParentEnfants(etat, details) {
  if (!details.utilisateur) return 'Verifier que la recherche utilise le bon identifiant ou courriel parent.';
  if (details.preuvesNegatives.some((item) => item.code === 'parent_inactif')) return 'Verifier le statut du compte parent dans l administration.';
  if (details.enfantsAttendus.length === 0) return 'Verifier la relation parent/enfant active dans l administration.';
  if (etat === 'sain') return 'Comparer avec le compte connecte si le support rapporte encore une anomalie UI.';
  return 'Verifier la projection enfants visibles et son age par rapport a la relation source.';
}

function rechercherUtilisateur(utilisateurs, texteRecherche) {
  const q = normaliserRecherche(texteRecherche);
  if (!q) return null;
  return utilisateurs.find((utilisateur) => (
    normaliserRecherche(utilisateur.id) === q
    || normaliserRecherche(utilisateur.courriel) === q
    || normaliserRecherche(utilisateur.email) === q
    || normaliserRecherche(utilisateur.nom).indexOf(q) >= 0
  )) || null;
}

function objetUtilisateur(utilisateur) {
  return {
    type: 'utilisateur',
    id: utilisateur.id,
    libelle: utilisateur.nom || utilisateur.courriel || utilisateur.id,
    etat: utilisateur.statut || 'inconnu',
    organisationId: utilisateur.organisationId || '',
  };
}

function ajouterPreuve(collection, code, libelle, source, objetId, horodatage, details) {
  collection.push(preuve(code, libelle, source, objetId, horodatage, details));
}

function preuve(code, libelle, source, objetId, horodatage, details = {}) {
  return {
    code,
    libelle,
    source,
    objetId: objetId || '',
    horodatage: horodatage || '',
    confiance: details.confiance || 'moyenne',
    details,
  };
}

function indexerParId(items) {
  return (items || []).reduce((index, item) => {
    index[item.id] = item;
    return index;
  }, {});
}

function normaliserRecherche(valeur) {
  return String(valeur || '').trim().toLowerCase();
}

function periodeJourCourant() {
  const maintenant = new Date();
  const debut = new Date(maintenant);
  debut.setHours(0, 0, 0, 0);
  const fin = new Date(maintenant);
  fin.setHours(23, 59, 59, 999);
  return {
    debut: debut.toISOString(),
    fin: fin.toISOString(),
  };
}

module.exports = {
  VERSION_CONTRAT_DIAGNOSTIC_SYNCUP,
  diagnostiquerObjetSyncUp,
  diagnostiquerParentEnfants,
  diagnosticNonInterprete,
  obtenirFluxSyncUp,
};



// WEBPACK FOOTER //
// src/components/cockpitSyncUp/moteurDiagnosticSyncUp.js